var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticClass:"pa-4 flex-grow-1 overflow-hidden"},[_c('v-card',{attrs:{"id":"mainContent"}},[(_vm.showRouterView)?_c('router-view'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }